import one from '@mailobj-browser/front/js/selectors/one.js'

export default checkbox => {
  const { ownerDocument } = checkbox
  
  if (!one('script[data-current]', ownerDocument)) {
    checkbox.checked = true
  }
}
